<template>
  <div class="app-sidebar">
    <nav class="sidebar-nav">
      <router-link to="/dashboard" :class="['sidebar-nav-item', { 'sidebar-nav-item-active': selectedKey === 'dashboard' }]">
        <DashboardIcon :size="20" class="sidebar-icon" />
        <span class="sidebar-label">Dashboard</span>
      </router-link>
      <router-link to="/patients" :class="['sidebar-nav-item', { 'sidebar-nav-item-active': selectedKey === 'patients' }]">
        <PatientIcon :size="20" class="sidebar-icon" />
        <span class="sidebar-label">Patients</span>
      </router-link>
      <router-link to="/tickets" :class="['sidebar-nav-item', { 'sidebar-nav-item-active': selectedKey === 'tickets' }]">
        <TicketOutline :size="20" class="sidebar-icon" />
        <span class="sidebar-label">Tickets</span>
      </router-link>
      <router-link to="/receivables" :class="['sidebar-nav-item', { 'sidebar-nav-item-active': selectedKey === 'receivables' }]">
        <ReceivableOutline :size="20" class="sidebar-icon" />
        <span class="sidebar-label">Receivables</span>
      </router-link>
      <router-link to="/payments" :class="['sidebar-nav-item', { 'sidebar-nav-item-active': selectedKey === 'payments' }]">
        <PaymentOutline :size="20" class="sidebar-icon" />
        <span class="sidebar-label">Payments</span>
      </router-link>
      <router-link to="/products" :class="['sidebar-nav-item', { 'sidebar-nav-item-active': selectedKey === 'products' }]">
        <ProductOutline :size="20" class="sidebar-icon" />
        <span class="sidebar-label">Products</span>
      </router-link>
      <router-link
        v-if="trtEnabled"
        to="/trt"
        :class="['sidebar-nav-item', { 'sidebar-nav-item-active': selectedKey === 'trt' }]"
      >
        <TRTIcon :size="20" class="sidebar-icon" />
        <span class="sidebar-label">TRT</span>
      </router-link>
      <div
        v-else
        class="sidebar-nav-item sidebar-nav-item-disabled"
        title="TRT is only available in the EMR extension"
      >
        <TRTIcon :size="20" class="sidebar-icon" />
        <span class="sidebar-label">TRT</span>
      </div>
    </nav>
  </div>
</template>

<script>
import DashboardIcon from 'vue-material-design-icons/ViewDashboard.vue';
import PatientIcon from 'vue-material-design-icons/Account.vue';
import TicketOutline from 'vue-material-design-icons/Tag.vue';
import ReceivableOutline from 'vue-material-design-icons/Clock.vue';
import PaymentOutline from 'vue-material-design-icons/CreditCard.vue';
import ProductOutline from 'vue-material-design-icons/Cart.vue';
import TRTIcon from 'vue-material-design-icons/Needle.vue';
import { isExtensionMode } from '@/libs/extensionAuth';

export default {
  name: 'AppSidebar',
  computed: {
    trtEnabled() {
      // TRT relies on the EMR extension bridge, so only expose it in extension mode.
      return isExtensionMode()
    },
    selectedKey() {
      const path = this.$route.path
      if (path.startsWith('/dashboard')) {
        return 'dashboard'
      } else if (path.startsWith('/patients')) {
        return 'patients'
      } else if (path.startsWith('/tickets')) {
        return 'tickets'
      } else if (path.startsWith('/products')) {
        return 'products'
      } else if (path.startsWith('/trt')) {
        return 'trt'
      } else if (path.startsWith('/receivables')) {
        return 'receivables'
      } else if (path.startsWith('/payments')) {
        return 'payments'
      }
      return null
    }
  },
  components: {
    DashboardIcon,
    PatientIcon,
    TicketOutline,
    ReceivableOutline,
    PaymentOutline,
    ProductOutline,
    TRTIcon,
  }
}
</script>

<style scoped>
.app-sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: var(--app-sidebar-width);
  height: 100%;
  background: var(--app-sidebar-bg);
  box-shadow: 2px 0px 4px #00000022;
}

.sidebar-nav {
  display: flex;
  flex-direction: column;
  padding: 8px 0;
}

.sidebar-nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--app-sidebar-text);
  cursor: pointer;
  text-decoration: none;
  padding: 12px 8px;
  gap: 2px;
  transition: all 0.2s;
  user-select: none;
  border-left: 3px solid transparent;
}

.sidebar-nav-item:hover {
  color: var(--app-sidebar-text-hover);
  background: #ffffff0d;
}

.sidebar-nav-item-active {
  color: var(--app-sidebar-text-hover);
  background: rgba(255, 255, 255, 0.08);
  border-left-color: var(--primary-color);
}

.sidebar-nav-item-disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.sidebar-nav-item-disabled:hover {
  color: var(--app-sidebar-text);
  background: transparent;
}

.sidebar-icon {
  margin-bottom: 4px;
}

.sidebar-label {
  font-size: 10px;
  text-align: center;
}
</style>